
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[productPage]",
      function () {
        return require("private-next-pages/[productPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[productPage]"])
      });
    }
  